import { PROVIDERS, getProviderEnabled } from '@exodus/fiat-client'
import blockchainProvider, {
  ENABLED_ASSETS,
  getWidgetUrl as getBlockchainWidgetUrl,
} from '@exodus/fiat-client/blockchain'

const createProvider = ({ assets, config, enabled, kyc, ...options } = Object.create(null)) =>
  blockchainProvider({
    ...options,
    apiKey: config.API_KEY,
    assets: {
      ...ENABLED_ASSETS,
      ...assets,
    },
    enabled: (args) =>
      getProviderEnabled({ ...args, enabled, kyc, provider: PROVIDERS.blockchain }),
    url: config.API_URL,
  })

export const getWidgetUrl = async (
  { assets, config, countryCode, orderId, paymentMethod, ...options } = Object.create(null)
) =>
  getBlockchainWidgetUrl({
    ...options,
    apiKey: config.API_KEY,
    assets: {
      ...ENABLED_ASSETS,
      ...assets,
    },
    orderId,
    paymentMethod,
    url: config.URL,
  })

export default createProvider
